import React, { useContext, useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { SelectDataType, MeasureInfoType } from './XYDiagram';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { GetRealTimeTrendGroupTableByItemSet, GetTrendGroupTableByItemSet } from '../../../function/GroupDataModel';
import RealTimeTrendGraphGroupSelectPage from '../../Pages/RealTimeTrendGraph/RealTimeTrendGraphGroupSelectPage';
import TrendGraphGroupSelectPage from '../../Pages/TrendGraph/TrendGraphGroupSelectPage';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);

/**ダイアログ表示モードキー */
const DialogKindKey = {
  None: 'None',
  RealTime: 'realTime',
  Trend: 'trend',
} as const;

/**ダイアログ表示タイプ */
type DialgKindType = typeof DialogKindKey[keyof typeof DialogKindKey];

/**引数 */
type Props = {
  selectData: SelectDataType;
  measureInfo: MeasureInfoType[];
};

/**XY分布下部ボタンコンポーネント */
const XYDiagramButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { login } = useContext(AppContext);

  const { selectData, measureInfo } = props;
  const classes = useStyles();
  const [gropuSelectDialogOpen, setGropuSelectDialogOpen] = React.useState(false);
  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);

  const [dialogKind, setDialogKind] = React.useState<DialgKindType>(DialogKindKey.None);
  const [selectGroupNos, setSelectGroupNos] = React.useState<number[]>([0]);

  /**
   *リアルタイムトレンドボタン処理
   */
  const handleRealTimeTrendPageOpen = () => {
    setDialogKind(DialogKindKey.RealTime);
    var xDt = measureInfo.find((row) => row.id === selectData.xid);
    var yDt = measureInfo.find((row) => row.id === selectData.yid);

    GetRealTimeTrendGroupTableByItemSet().then((ret) => {
      var xDts = ret?.filter((row) => row.trdItemSet.PLC_NO == xDt?.PlcNo && row.trdItemSet.SET_NO === xDt?.SetNo);
      var yDts = ret?.filter((row) => row.trdItemSet.PLC_NO == yDt?.PlcNo && row.trdItemSet.SET_NO === yDt?.SetNo);

      console.debug(['selectDt,xDt,yDt', selectData, xDt, yDt]);
      console.debug(['itemSet , xDts,yDts', ret, xDts, yDts]);
      var targets = xDts.concat(yDts);
      console.debug(['targets', targets]);

      if (targets.length !== 0) {
        var gpNos: number[] = [];
        for (var i in targets) {
          gpNos.push(targets[i].trdGroupSet.GROUP_NO);
        }
        setSelectGroupNos(gpNos);
      } else {
        handleSimpleDialogClickOpen();
        return;
      }
      handleGroupSelectDialogShow();
    });
  };

  /**
   *傾向管理ボタン処理
   */
  const handleTrendPageOpen = () => {
    setDialogKind(DialogKindKey.Trend);
    var xDt = measureInfo.find((row) => row.id === selectData.xid);
    var yDt = measureInfo.find((row) => row.id === selectData.yid);

    GetTrendGroupTableByItemSet().then((ret) => {
      var xDts = ret.filter((row) => row.trdItemSet.PLC_NO == xDt?.PlcNo && row.trdItemSet.SET_NO === xDt.SetNo);
      var yDts = ret.filter((row) => row.trdItemSet.PLC_NO == yDt?.PlcNo && row.trdItemSet.SET_NO === yDt.SetNo);

      console.debug(['selectDt,xDt,yDt', selectData, xDt, yDt]);
      console.debug(['itemSet , xDts,yDts', ret, xDts, yDts]);
      var targets = xDts.concat(yDts);
      console.debug(['targets', targets]);

      if (targets.length !== 0) {
        var gpNos: number[] = [];
        for (var i in targets) {
          gpNos.push(targets[i].trdGroupSet.GROUP_NO);
        }
        setSelectGroupNos(gpNos);
      } else {
        handleSimpleDialogClickOpen();
        return;
      }
      handleGroupSelectDialogShow();
    });
  };

  /**
   * グループ選択ダイアログ表示
   */
  const handleGroupSelectDialogShow = () => {
    setGropuSelectDialogOpen(true);
  };

  /**
   * グループ選択ダイアログ閉じる
   */
  const handleGroupSelectDialogClose = () => {
    setGropuSelectDialogOpen(false);
  };

  /**メッセージボックス表示 */
  const handleSimpleDialogClickOpen = () => {
    setSimpleDialogOpen(true);
  };

  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  return (
    <Grid container>
      <Grid item xs={2}>
        <Button className={classes.buttonStyle} variant="contained" color="primary" onClick={handleTrendPageOpen}>
          {t('XYDiagramButtonList.傾向管理', '傾向管理')}
        </Button>
      </Grid>
      {login.IsIoT === true ? (
        ''
      ) : (
        <Grid item xs={2}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={handleRealTimeTrendPageOpen}
          >
            {t('XYDiagramButtonList.リアルタイムトレンド', 'リアルタイムトレンド')}
          </Button>
        </Grid>
      )}

      <SimpleDialog
        open={gropuSelectDialogOpen}
        onClose={handleGroupSelectDialogClose}
        title={t('XYDiagramButtonList.グループ選択', 'グループ選択')}
        okText={t('XYDiagramButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        {dialogKind == DialogKindKey.RealTime ? (
          <RealTimeTrendGraphGroupSelectPage defalutGropuNos={selectGroupNos ?? []} />
        ) : (
          <TrendGraphGroupSelectPage defalutGropuNos={selectGroupNos} />
        )}
      </SimpleDialog>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={t('XYDiagramButtonList.グループ選択', 'グループ選択')}
        okText={t('XYDiagramButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>
          {t('XYDiagramButtonList.グループが見つかりませんでした', 'グループが見つかりませんでした')}
        </Typography>
      </SimpleDialog>
    </Grid>
  );
};

export default XYDiagramButtonList;
